/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpsertDocumentRequest } from '../../models/upsert-document-request';

export interface UpdateDocument$Params {
  idDocument: string;
  body: UpsertDocumentRequest;
}

export function updateDocument(
  http: HttpClient,
  rootUrl: string,
  params: UpdateDocument$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, updateDocument.PATH, 'put');
  if (params) {
    rb.path('idDocument', params.idDocument, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

updateDocument.PATH = '/v2/documents/{idDocument}';
